import { Component, OnInit } from '@angular/core';
import { AboutService } from '@sb-core/services/about.service';
import { TableColumns } from '@sb-shared/models/UI/table';

@Component({
  selector: 'sb-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  standalone: false
})
export class AboutComponent implements OnInit {
  isLoading = true;
  versionItems = {};
  versions = [];

  private siteVersionLoaded = false;
  private componentVersionsLoaded = false;

  tableColumns: TableColumns = [
    {
      id: 'name',
      name: 'SB_Name',
      isDefaultSort: true,
      semiBold: true
    },
    {
      id: 'version',
      name: 'SB_Version'
    }
  ];

  constructor(private aboutService: AboutService) {}

  ngOnInit(): void {
    this.aboutService.getSiteVersion().subscribe((data: string) => {
      this.addVersion('SPA', data);
      this.siteVersionLoaded = true;
      this.updateLoading();
    });

    this.aboutService.getComponentVersions().subscribe(data => {
      data.forEach(item => {
        this.addVersion(item.name, item.version);
      });
      this.componentVersionsLoaded = true;
      this.updateLoading();
    });
  }

  private addVersion(subsystem: string, version: string) {
    this.versionItems[subsystem] = version;

    this.versions = Object.keys(this.versionItems)
      .map(key => {
        return {
          name: key,
          version: this.versionItems[key]
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  private updateLoading() {
    this.isLoading = !(this.siteVersionLoaded && this.componentVersionsLoaded);
  }
}
